import React from 'react';
import { PrivateLayout } from '~/Layout/PrivateLayout';
import VoDVideosList from './VoDVideosList/VoDVideosList';
import { useNavigation, useProvider, useLanguage } from '~/Hooks';
import { routeReplacer } from '~/Helpers/String.helper';
import { Route } from '~/Constants/Routes.constants';

export const VideoOnDemand = () => {
  const { t } = useLanguage();
  const { currentProvider } = useProvider();
  const { navigate } = useNavigation();

  const handleAddButtonClick = () => {
    navigate(
      routeReplacer(Route.VIDEO_ON_DEMAND_CREATE, { domain: currentProvider?.domain || '' }),
    );
  };

  return (
    <PrivateLayout
      title={{
        title: t('app.vod'),
        mobileActionName: t('app.vod.add'),
        onAddButtonClick: handleAddButtonClick,
        actionName: t('app.vod.add'),
      }}
      hideBackButton
    >
      <VoDVideosList />
    </PrivateLayout>
  );
};
